
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class DocumentUploadReaderService {

   public static getPresignedURLForUpload(
           axiosInstance: AxiosInstance, input: ServerData.DocumentUploadWebReader.GetPresignedURLForUpload$Input,
           f: (output: ServerData.DocumentUploadWebReader.GetPresignedURLForUpload$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/documentupload/get-presigned-u-r-l-for-upload',
            {params : input.toJson()}
        ).then((response) => ServerData.DocumentUploadWebReader.GetPresignedURLForUpload$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getUploadedUrl(
           axiosInstance: AxiosInstance, input: ServerData.DocumentUploadWebReader.GetUploadedUrl$Input,
           f: (output: ServerData.DocumentUploadWebReader.GetUploadedUrl$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/documentupload/get-uploaded-url',
            {params : input.toJson()}
        ).then((response) => ServerData.DocumentUploadWebReader.GetUploadedUrl$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getDocumentList(
           axiosInstance: AxiosInstance, input: ServerData.DocumentUploadWebReader.GetDocumentList$Input,
           f: (output: ServerData.SpineData$DocumentDetails[]) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/documentupload/get-document-list',
            {params : input.toJson()}
        ).then((response) => (response.data as object[]).map((x) => ServerData.SpineData$DocumentDetails.fromJson(x)))
       .then((output) => f(output))
       .catch(theEh);
   }


}

